module.exports = __webpack_public_path__ + "static/media/bg.817f0bfd.jpg";